import { createContext } from 'react'

export type UserGuideContextType = {
  isUserGuideOpen: boolean
  toggleUserGuide: () => void
  closeUserGuide: () => void
  userGuideUrl: string
}

const initialValue: UserGuideContextType = {
  isUserGuideOpen: false,
  toggleUserGuide: () => null,
  closeUserGuide: () => null,
  userGuideUrl: '',
}

export const UserGuideContext =
  createContext<UserGuideContextType>(initialValue)
